<!-- this is the page for the modal for the edit in the Admin Transaction. If later on decided to use modal, this page can
 be further developed -->

<template>
  <span>
    <b-modal
      ref="showTransactioModal"
      hide-header
      hide-footer
      no-close-on-backdrop
          size="lg"
          body-class="custom_alert_body"
    >
      <h4 slot="header" class="card-container">{{ pageTitle }}</h4>
      <!-- <div class="card card-body agatrs-card-style"> -->
      <div class="container">
        <!-- <div class="col-md-12"> -->
          <!-- don't need a form, each change has its own modal with submit inside it. -->
          <!-- <form @submit.prevent="updateTransaction"> -->
          <div class="row align-center">
            <div class="col-md-6">
              <base-input
                type="text"
                disabled
                label="Order Number"
                placeholder="Order Number"
                v-model="transaction.orderId"
              >
              </base-input>
            </div>

            <div class="col-md-6">
              <base-input
                type="text"
                disabled
                label="Requisition Number"
                placeholder="Requisition Number"
                v-model="transaction.requisitionNumber"
              >
              </base-input>
            </div>
          </div>
        
          <div class="row align-center">
            <div class="col-md-12">
              <label>Order Assigned to Logistics:</label>
              <logistics-user-select
                v-bind:orderIdProp="orderId"
                :is-read-only="isViewOnly"
              ></logistics-user-select>
            </div>
            <!-- <div class="col-md-6">
              <base-input label="Please specify a reason for change: ">
                <textarea
                  class="form-control"
                  placeholder="Add a brief description"
                  rows="1"
                  v-model="preOrder.remarks"
                ></textarea>
              </base-input>
            </div>
             <div class="col-md-6">
              <base-button
                type="primary"
                class="alert_footer_button btn_extra_small btn_info"
                @click.native="confirm"
              >
                Confirm
              </base-button>
            </div> -->
          </div>
          <div class="row align-center">
            <div class="col-md-12">
              <label>Order Assigned to Finance:</label>
              <finance-user-select
                :is-read-only="isViewOnly"
                v-bind:orderIdProp="orderId"
              ></finance-user-select>
            </div>
            <!-- <div class="col-md-6">
              <base-input label="Please specify a reason for change: ">
                <textarea
                  class="form-control"
                  placeholder="Add a brief description"
                  rows="1"
                  v-model="preOrder.remarks"
                ></textarea>
              </base-input>
            </div>
            <div class="col-md-6">
              <base-button
                type="primary"
                class="alert_footer_button btn_extra_small btn_info"
                @click.native="confirm"
              >
                Confirm
              </base-button>
            </div> -->
          </div>
          <div class="col-sm-12 more-top-padding">
            <label for="methodOfPayment">Method of Payment</label>
            <!-- <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="ModeOfPayToolTip_Name" :name="ModeOfPayToolTip_Name" :description="ModeOfPayToolTip_Description" :editable="editable"></tool-tip> -->

            <br />
              <el-radio-group
                v-model="orderMetadata.paymentMethodId" :disabled="checkMonetary()" v-validate="'required'" data-vv-as="Method of Payment" name="paymentMethod" :error="getError('paymentMethod')"
              >
              <el-radio
                tabindex="0"
                @change="viewModal"
                v-for="paymentMethod in paymentMethods"
                :label="paymentMethod.paymentMethodId"
                :key="paymentMethod.paymentMethodId"
                >{{ paymentMethod.name}}</el-radio>
              
              </el-radio-group>
            <br>
          </div>
          <div class="col-md-12">
            <base-input label="Please specify a reason for change: ">
              <textarea
                class="form-control"
                placeholder="Add a brief description"
                rows="5"
                v-model="preOrder.remarks"
              ></textarea>
            </base-input>
          </div>
          <div class="container alert_footer">
            <base-button
                type="danger"
                class="alert_footer_button btn_extra_small btn_info"
                @click.native="hide"
              >
                Close
              </base-button>
              <base-button
                type="primary"
                class="alert_footer_button btn_extra_small btn_info"
                @click.native="updatePreOrder"
              >
                Confirm
              </base-button>
          </div>
          <!-- </div> -->
          

<!-- 
            <modal
              :show.sync="modals.notice"
              headerClasses="justify-content-center"
              type="notice"
            > -->

            <!-- <template slot="footer">
              <div class="container alert_footer">
                <base-button
                  type="danger"
                  class="alert_footer_button btn_extra_small btn_info"
                  @click.native="cancel"
                >
                  Close
                </base-button>
                <base-button
                  type="primary"
                  class="alert_footer_button btn_extra_small btn_info"
                  @click.native="updatePreOrder"
                >
                  Confirm
                </base-button>
              </div>
            </template> -->
            <!-- </modal> -->
      </div>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import { Select, Option, Radio, RadioGroup } from "element-ui";
import { Modal} from "@/components";

import Header from "@/components/App/Header.vue";
import LogisticsUserSelect from "@/components/App/order/user/LogisticsUserSelect";
import FinanceUserSelect from "@/components/App/order/user/FinanceUserSelect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import axios from "@/axios";
import Util from "@/util/util";

export default {
  name: "EditModal",
  props: {
    id: {
      type: Number,
      default: undefined
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    Header,
    [Radio.name]: Radio, 
    [RadioGroup.name]: RadioGroup,
    LogisticsUserSelect,
    FinanceUserSelect,
    Modal
  },
  data() {
    return {
      showModal: false,
      orderId: this.id,
      modals: {
        notice: false,
        transaction: false
      },
      sendAssignerCopy: false,
      note: null,
      preOrder: {},
      oldPaymentOfMenthod: ''
    };
  },
  computed: {
    ...mapGetters({
      transaction: "transactions/transaction",
      financeUsers: "users/financeUsers",
      logisticsUsers: "users/logisticsUsers",
      orderMetadata: "orderMetadata/orderMetadata",
      paymentMethods: "paymentmethod/paymentMethods"
    }),
    isViewOnly() {
      return (
        this.$route.path === `/admin/transactions/view/${this.$route.params.id}`
      );
    },
    pageTitle() {
      return this.isViewOnly ? "View Transaction" : "Edit Transaction";
    },
  },

  methods: {
    ...mapActions({
      getLogisticsUsers: "users/getLogisticsUsers",
      getFinanceUsers: "users/getFinanceUsers",
      updateTransaction: "transactions/updateTransaction",
      getTransaction: "transactions/getTransaction",
      getPaymentMethods: "paymentmethod/getPaymentMethods",

    }),
    async load() {
      console.log(this.id, this.orderId);
      if (this.id != undefined) {
        await this.getTransaction(this.orderId);
        await this.getFinanceUsers(false);
        await this.getPaymentMethods();
        
        await this.getLogisticsUsers(false);
        await this.getPreOrder(this.orderId);
        this.oldPaymentOfMenthod = this.orderMetadata.paymentMethodId;
      }
    },
    async show(id) {
      this.orderId = id;
      this.modals.transaction = true;
      await this.$refs.showTransactioModal.show();
      await this.load();
    },
    async hide() {
      this.orderId = undefined;
      await this.getPreOrder();
//      this.modals.notice = false;
      this.modals.transaction = true;
      await this.$refs.showTransactioModal.hide();
      this.$emit('modal-close');
    },
    checkMonetary() {
      if (this.orderMetadata.paymentMethodId === Util.MONETARY) {
        return true
      }
      return false
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    viewModal(e) {
      this.selectedUserId = e;
      this.modals.notice = true;
    },
    async cancel(e) { 
      await this.getPreOrder();
      this.modals.notice = false;
    },
    async getPreOrder() {
      var res = await axios.get(`/api/orders/preorder/${this.id}`);
      this.preOrder = res.data;
    },
    async updatePreOrder() {
      try {
        this.$loaderApp.addRequest();
        this.paymentMethodChanged(this.orderMetadata.paymentMethodId);
        if (!(this.preOrder === undefined || this.preOrder.orderId === 0)) {
          if(this.orderMetadata.paymentMethodId === Util.MONETARY && this.oldPaymentOfMenthod !== this.orderMetadata.paymentMethodId) {
            this.preOrder['isMethodToMonetary'] = true;
          } else {
            this.preOrder['isMethodToMonetary'] = false;
          }
          await this.savePreOrderAdmin();
        } else {
          this.modals.notice = true
            this.$toast.error("Error on saving");
        }
        this.$loaderApp.completeRequest();

      } catch(e) {
        this.$loaderApp.completeRequest();
          this.modals.notice = true
        this.$toast.error('Error on updating');
      }
      return;
    },
    async savePreOrderAdmin() {
      try {
        let ret = await this.$validator.validateAll();
        if(ret) {
          const dataToSend = Object.assign({}, this.preOrder);
          const options = {
            'Content-Type': 'application/json'
          };
          //The DODAAC must be null or a valid 6 character string when sent to the server.  If it is an empty string set it to null.
          if (!Util.isNull(dataToSend) && Util.isNullOrEmpty(dataToSend.dodAac)) {
              dataToSend.dodAac = null;
          }
          if (this.preOrder.remarks) {
            if (!Util.isNullOrEmpty(this.preOrder.remarks.trim())) {
              await axios.post('/api/orders', dataToSend, options);
              await this.getTransaction(this.id);
              await this.getPreOrder(this.id);
              this.modals.notice = false;
            } else {
              this.modals.notice = true;
              this.$toast.error("Remarks cannot be empty");

            }
          } else {
            this.$toast.error("Remarks cannot be empty");
          }
        
        }
      } catch(e) {
        this.$toast.error('Error on updating');
      }
    },
    async updateTransactionLocal(id) {
      let ctx = this;
      await ctx.updateTransaction();
    },
    paymentMethodChanged(paymentMethodId) {
      try {
        if (paymentMethodId === Util.MONETARY) {
          if(this.preOrder.lssTypeId === Util.STANDARD || this.preOrder.lssTypeId === Util.OPEN_ENDED) {
            this.preOrder.hasAcsaCeiling = "YES"
            this.preOrder.paymentMethodId = paymentMethodId
            return;
          }
          if(this.preOrder.lssTypeId === Util.SME_LOAN || this.preOrder.lssTypeId === Util.LIFT_AND_SUSTAIN || this.preOrder.lssTypeId === Util.STRATEGIC_AIRLIFT) {
            this.preOrder.hasAcsaCeiling = "NO"
            this.preOrder.paymentMethodId = paymentMethodId
            return;
          }
        }
        this.preOrder.hasAcsaCeiling = null;
        this.preOrder.acsaCeilingJustification = null;
        this.preOrder.paymentMethodId = paymentMethodId
      } catch(e) {
        this.$toast.error(e);
      }
     
    },
  },
};
</script>

<style>
.more-width {
  width: 50%;
}
</style>
